import _ from 'underscore';
import BaseFilterView from './base-filter-view';
import ProjectUtil from '../utils/project-util';
//import template from '../../handlebars/client/people-list-filtered.hbs';
class PeopleListFilter extends BaseFilterView {
	constructor(options = {}) {
		super(options);
	}

	viewEvents() {
		return {};
	}

	postInitialize() {
		this.viewEvents = {};
	}

	bindings() {
		//_.bindAll(this, 'render', 'destroy');
	}

	// override as necessary for child-view-specific listeners
	childViewListeners() {
		return {};
	}

	setTemplate() {
		return import(/* webpackChunkName: "people-list-filter" */ '../../handlebars/client/people-list-filtered.hbs')
			.then((templateModule) => {
				this.template = templateModule.default;
			});
	}

	/**
	 * Overwrite if necessary, adding to postRenderView() should suffice for your needs.
	 * 
	postRender() {
		
	}
	*/

	/**
	 * View-specific post-render actions.  Define this.listTemplate and this.apiCall here for sure.
	 */
	postRenderView() {
		this.moduleDataObj = ProjectUtil.getObjByProp(this.model.get('page').content.modules, 'id', this.$el.data('mod-id'));
		// the API call being made
		this.apiCall = 'people';
		// the name of the template being rendered for items list
		//this.template = template;
		// destination for filtered lists
		this.$itemListDest = $('#people-list-dest', this.$el);
		this.loadEventData = (!this.model.get('site').categories.hasOwnProperty('judges_events')) ? true : false;
	}

	/**
	 * Build the querystring used for updating the url.  This should be defined per view.
	 */
	buildQueryString() {
		var //expertise_filter = this.getSelectFilterValues('expertise'), // this.getSelectFilterValues('expertise'),
			//vision_filter = this.getCheckboxFilterValues('vision'),
			//programs_filter = this.getSelectFilterValues('programs'),
			//department_filter = this.getCheckboxFilterValues('depts'),
			//centers_filter = this.getCheckboxFilterValues('centers'),
			events_filter = this.getSelectFilterValues('events'), // get the values for the select with id 'events'
			//type_filter = this.getSelectFilterValues('type'),
			//letter_filter = this.getAlphaFilterVal(),
			queryStringAr = [];
		/*
		if (expertise_filter.length) {
			queryStringAr.push('tag=' + expertise_filter);
		}
		if (vision_filter.length) {
			queryStringAr.push('vision=' + vision_filter);
		}
		if (programs_filter.length) {
			queryStringAr.push('programs=' + programs_filter);
		}
		if (department_filter.length) {
			queryStringAr.push('department=' + department_filter);
		}
		if (centers_filter.length) {
			queryStringAr.push('centers=' + centers_filter);
		}
		*/
		/*if (letter_filter.length) {
			queryStringAr.push('letter=' + letter_filter.join('|'));
		}*/
		if (events_filter.length) {
			queryStringAr.push('events=' + events_filter);
		}

		if (queryStringAr.length) {
			return '?' + queryStringAr.join('&');
		}
		return '';
	}

	/**
	 * Build the Data Object for the API request.  This happens during handleUpdateQsFilters() and should be defined per view.
	 */
	getRequestData() {
		// update the API call being made
		//this.apiCall = this.getQueryString('type') || 'posts';
		let requestData = {
			//expertise_news: this.getQueryString('tag'),
			//vision: this.getQueryString('vision'),
			//program_news: this.getQueryString('programs'),
			//depts: this.getQueryString('department'),
			//centers: this.getQueryString('centers'),
			event_id: this.getQueryString('events') || '', // get the values for the querystring 'events'
			search: $('#filter-search', this.$el).length ? $('#filter-search', this.$el).val().toLowerCase().split(' ').join('+') : '',
			pnum: this.curPage,
			// do we need to load event filter data
			inc_events: this.loadEventData ? 1 : 0,
			perpage: 1000,
		};

		/*
		// verify alpha filter
		requestData.letter = this.getQueryString('letter');
		if (requestData.letter === undefined) {
			requestData.letter = '';
		}

		// update alpha selectLabel
		console.log('[PeopleListFilter].getRequestData()::requestData.letter:', requestData.letter);
		if (requestData.letter === '') {
			this.$selectLabel.html('A-Z');
			console.log('[PeopleListFilter].getRequestData():: set $selectLabel to A-Z ');
		} else {
			this.$selectLabel.html(requestData.letter);
			console.log('[PeopleListFilter].getRequestData():: set $selectLabel to ' + requestData.letter);
		}


		console.log('[PeopleListFilter].getRequestData()::requestData:', requestData);
		console.log('[PeopleListFilter].getRequestData()::this.$selectLabel: ', this.$selectLabel);
		*/
		return requestData;

	}

	/**
	 * Update display of filters. This happens during handleUpdateQsFilters() and should be defined per view.
	 */
	childUpdateFilters(/*tData*/) {
		// update checkboxes/selects here
		//this.setSelectFilterValues('expertise', tData.expertise_news);
		//this.setCheckboxFilterValues('vision', tData.vision);
		//this.setSelectFilterValues('programs', tData.program_news);
		//this.setCheckboxFilterValues('depts', tData.depts);
		//this.setCheckboxFilterValues('centers', tData.centers);

		//this.setSelectFilterValues('events', tData.events); // set the values for the select with id 'events'
	}

	childGetContent(tRes) {
		// add faculty expertise to site.categories, if there are results
		/*if (tRes.hasOwnProperty('data') &&
			tRes.data.hasOwnProperty('results') &&
			tRes.data.results.hasOwnProperty('judges_events')) {*/
		if (tRes?.data?.results?.judges_events?.length) {

			// process judges_events into new array take id as id, title as name
			let judgeRes = [];
			_.each(tRes.data.results.judges_events, function (tItem) {
				judgeRes.push({
					id: tItem.id,
					name: tItem.title
				});
			});

			// store this category in site settings
			this.model.get('site').categories.judges_events = judgeRes;
			// update select with this data
			let $tSelect = $('#events', this.$el),
				tActiveItemsAr = ProjectUtil.getQueryString('events').split('|');
			// add options to select for each judges_event
			_.each(tRes.data.results.judges_events, function (item) {
				$tSelect.append('<option value="' + item.id + '">' + item.title + '</option>');
			});
			// activate approriate items (from querystring)
			_.each(tActiveItemsAr, function (item) {
				$tSelect.find('option[value="' + item + '"]').prop('selected', true);
			});
			// update var to prevent additional loads
			this.loadEventData = false;
		}
	}
	childCleanup() {

	}


}

export default PeopleListFilter;
